import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';

export async function fetchCreditNoteList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/credit-note/credit-notes`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function getCreditNotes(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/credit-notes/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function getCreditNoteDetails(id) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/purchase/credit-notes/details/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function fetchCreditNoteDetails(id) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/credit-note/credit-notes/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
export async function fetchExcessPaymentCreditNoteDetails(vendorId) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(
			`${APP_API_URL}/purchase-bill/excess-bills/${vendorId}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function create_credit_note(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(`${APP_API_URL}/credit-note/credit-notes`, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (data.code === 422) {
			throw new Error(data.message[0].message);
		}
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export async function update_credit_note(id, body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.put(
			`${APP_API_URL}/credit-note/credit-notes/${id}`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (data.code === 422) {
			throw new Error(data.message[0].message);
		}
		return data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}

export const delete_credit_note = async (credit_note_ids) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/credit-note/delete-credit-notes`,
			{ credit_note_ids },
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
};

export async function sendEmail(body) {
	const token = localStorage.getItem('authToken');
	const { data } = await axiosInstance.post(`${APP_API_URL}/credit-note/send-email`, body, {
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	});
	return data;
}

export async function generatePurchaseCreditNotePdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/purchase/credit-notes/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
